import * as React from "react";
import { useOptIns, Utils } from "@grandvisionhq/auth";
import { toast, ScrollIntoView } from "@grandvisionhq/common";
import { Heading, Text } from "@grandvisionhq/elements";
import { Spinner, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { toUpdatedOptIns } from "../mappers/OptIns/mappers/opt-in-input.js";
import { toServerOptIns } from "../mappers/OptIns/mappers/opt-ins-server.js";
import { OptIns } from "./OptIns.js";
const OptInsContainer = () => {
  const intl = useIntl();
  const { getLabel } = intl;
  const onCompleted = React.useCallback((operation) => {
    if (operation === "MUTATION") {
      toast.success("account.updateOptins.success");
    }
  }, []);
  const onError = React.useCallback(({ reason }) => {
    if (reason === "MUTATION") {
      toast.failed("account.privacy.updateOptins.errors.general");
    }
  }, []);
  const { optInsFromServer, availableOptIns, isFetching, isUpdating, updateOptIns, fetchError } = useOptIns({
    onCompleted,
    onError
  });
  const [changedOptIns, setChangedOptIns] = React.useState({});
  const serverOptIns = toServerOptIns(optInsFromServer);
  const handleChange = (changedOptIns2) => {
    setChangedOptIns(changedOptIns2);
  };
  const handleSave = () => {
    const optInsUpdate = toUpdatedOptIns({
      changedOptIns,
      optInsFromServer,
      availableOptIns,
      getLabel: intl.getLabel
    });
    updateOptIns(optInsUpdate);
  };
  if (isFetching) {
    return /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") });
  }
  if (fetchError) {
    return /* @__PURE__ */ React.createElement(ScrollIntoView, null, /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, intl.getFormattedLabel("account.privacy.fetchOptins.errors.general", {
      parseLink: true
    })));
  }
  const ungroupedOptIns = Utils.ungroupOptIns(availableOptIns);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading, { variant: "small" }, intl.getLabel("account.settings.communicationPreferences")), /* @__PURE__ */ React.createElement(Text, null, intl.getLabel("account.settings.communicationPreferences.intro")), /* @__PURE__ */ React.createElement(
    OptIns,
    {
      intl,
      availableOptIns: ungroupedOptIns,
      selectedOptIns: getSelectedOptIns({
        server: serverOptIns,
        client: changedOptIns,
        availableOptIns: ungroupedOptIns
      }),
      onChange: handleChange,
      onSave: handleSave,
      isUpdating
    }
  ));
};
function getSelectedOptIns({
  server,
  client,
  availableOptIns
}) {
  let selectedKeys = [];
  if (Object.keys(client).length) {
    selectedKeys = Object.keys(client).reduce((selected, optInName) => {
      if (!client[optInName]?.checked) {
        return selected;
      }
      return [...selected, optInName];
    }, []);
  } else {
    selectedKeys = Object.entries(server.optinValues).filter(([_, value]) => value).map(([name]) => name);
  }
  return availableOptIns.filter((o) => selectedKeys.includes(o.value));
}
export {
  OptInsContainer as default,
  getSelectedOptIns
};
//# sourceMappingURL=OptInsContainer.js.map
